import { useTranslate } from "@similarweb/i18n-provider";

import { useIsDemoMode } from "app/pages/sales-intelligence/store/demo-mode/useDemoModeStore";
import { demoModeKeys } from "app/pages/sales-intelligence/utils/i18n/demo-mode";

interface IDemoModeDisabledState {
    /** True when the action should be disabled because a demo is active. */
    readonly isDisabled: boolean;
    /** Tooltip explaining the disablement, or undefined when not disabled. */
    readonly disabledTooltip: string | undefined;
}

export const useDemoModeDisabled = (): IDemoModeDisabledState => {
    const isDemoMode = useIsDemoMode();
    const { translate } = useTranslate();

    return {
        isDisabled: isDemoMode,
        disabledTooltip: isDemoMode ? translate(demoModeKeys.actionDisabled) : undefined,
    };
};
